import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  /* width: 80rem; */
  overflow-x: auto;
  margin: 2rem auto 1rem auto;
  height: fit-content;
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.8rem, calc(0.6rem + 0.4vw), 3rem);
`

export const GridContainer = styled.div<{columnCount: number}>`
  grid-template-columns: repeat(${props => props.columnCount+1}, auto);
  display: grid;
  max-width: 55rem;

  input:nth-of-type(1) {
      border-top-left-radius: 1rem;
  }
      
  input:nth-of-type(${props => props.columnCount}) {
      border-top-right-radius: 1rem;
  }

  input:nth-last-of-type(${props => props.columnCount}) {
      border-bottom-left-radius: 1rem;
  }
      
  input:last-of-type {
      border-bottom-right-radius: 1rem;
  }
`

export const HorizontalHeader = styled.div`
  width: 8rem;
  padding-bottom: 0.4rem;
`

export const VerticalHeader = styled.div`
  width: 8rem;
  display: flex;
  align-items: center;
`

export const CellInput = styled.input`
  width: 9rem;
  height: 2.5rem;
  padding: 0.5rem;
  background-color: #F4F4F4;
  border: 0;
  font-size: clamp(0.8rem, calc(0.8rem + 0.1vw), 10rem);

  :focus {
    outline: 0;
    border: 1px solid #000;
  }

  &.outsideTheNorm{
    background-color: #FFFCEE;
    color: #9D7D07;

    ::-webkit-input-placeholder {
      color: #9D7D07;
    }
  }
`
